import React from 'react';
import PropTypes from 'prop-types';
import { connectHits } from 'react-instantsearch-dom';
import Grid from '../../Grid';
import HitComponent from '../HitComponent';
import Typography from '../../Typography';

const HitsComponent = ({ hits, emptyMessage }) => (
  <Grid row spacing={16} className="mt-32">
    {hits.map(hit => (
      <HitComponent key={hit?.reference} hit={hit} />
    ))}
    {hits.length === 0 && (
      <Grid column xs={12}>
        <Typography align="center" variant="h5" component="div" color="gray-700" className="my-24">
          {emptyMessage}
        </Typography>
      </Grid>
    )}
  </Grid>
);

HitsComponent.propTypes = {
  emptyMessage: PropTypes.string,
  hits: PropTypes.array,
};

HitsComponent.defaultProps = {
  emptyMessage: undefined,
  hits: [],
};

export default connectHits(HitsComponent);
